import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import LocalService from '../../../../../../services/local-auth';
import SecretariaService from '../../../../../../services/secretaria';
import { Link, useParams, Navigate } from 'react-router-dom';


const Local = () => {
    let { id } = useParams()

    const [nome, setNome] = useState("");
    const [endereco, setEndereco] = useState("");
    const [horarios, setHorarios] = useState("");
    const [telefone, setTelefone] = useState("");
    const [telefonePlantao, setTelefonePlantao] = useState("");
    const [email, setEmail] = useState("");
    const [responsavel, setResponsavel] = useState("");
    const [secretaria, setSecretaria] = useState("");
    const [secretarias, setSecretarias] = useState([])
    const [descricao, setDescricao] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    const montaSec = async () => {
        const secs = await SecretariaService.listar()
        setSecretarias(secs.data)
    }

    async function fetchLocal(id) {
        await montaSec();
        const response = await LocalService.locEdit(id);
        setNome(response.data["nome"]);
        setEndereco(response.data["endereco"]);
        setHorarios(response.data["horarios"]);
        setTelefone(response.data["telefone"]);
        setEmail(response.data["email"]);
        setSecretaria(response.data["secretaria"]);
        setTelefonePlantao(response.data["telefonePlantao"]);
        setResponsavel(response.data["responsavel"]);
        setDescricao(response.data["descricao"]);
    }

    useEffect(() => {
        fetchLocal(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const local = await LocalService.editar(id, {
                nome: nome,
                endereco: endereco,
                horarios: horarios,
                telefone: telefone,
                telefonePlantao: telefonePlantao,
                email: email,
                secretaria: secretaria,
                responsavel: responsavel,
                descricao: descricao
            })
            if (local.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="Processo">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Secretaria"
                                        name="secretaria"
                                        onChange={e => setSecretaria(e.target.value)}
                                    >
                                        <option value={secretaria}>{secretaria}</option>
                                        {secretarias.map((sec) =>
                                            <option value={sec.nome}>{sec.nome}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome do Local"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="endereco">
                                <FloatingLabel
                                    label="Endereço até o bairro"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="endereco"
                                        value={endereco}
                                        onChange={e => setEndereco(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="horarios">
                                <FloatingLabel
                                    label="Horários de Funcionamento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="horarios"
                                        value={horarios}
                                        onChange={e => setHorarios(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="telefone">
                                <FloatingLabel
                                    label="Telefone de Atendimento (2554-XXXX)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="telefone"
                                        value={telefone}
                                        onChange={e => setTelefone(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="telefonePlantao">
                                <FloatingLabel
                                    label="Telefone de Plantão"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="telefonePlantao"
                                        value={telefonePlantao}
                                        onChange={e => setTelefonePlantao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="email">
                                <FloatingLabel
                                    label="E-mail"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="responsavel">
                                <FloatingLabel
                                    label="Responsável pelo local"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="responsavel"
                                        value={responsavel}
                                        onChange={e => setResponsavel(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="telefone">
                                <FloatingLabel
                                    label="Descrição dos Serviços Prestados"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="descricao"
                                        value={descricao}
                                        onChange={e => setDescricao(e.target.value)} 
                                        as="textarea"
                                        rows={5}
                                        />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/institucional/locais/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Órgão editado com sucesso!</Alert>
                <Navigate to={'/restrito/institucional/locais/listar'} />
            </Fragment>
        )
    }
}

export default Local;